import AttendAgreement36ApplicationPage from './AttendAgreement36ApplicationPage';

export default AttendAgreement36ApplicationPage;
